var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVertexCut(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M73.656,46H60.433c-0.906-3.808-4.328-6.652-8.41-6.652c-1.104,0-2,0.896-2,2s0.896,2,2,2c2.565,0,4.652,2.087,4.652,4.652 s-2.087,4.652-4.652,4.652c-1.104,0-2,0.896-2,2s0.896,2,2,2c4.081,0,7.503-2.844,8.41-6.652h13.223c1.104,0,2-0.896,2-2 S74.761,46,73.656,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.977,43.348c1.104,0,2-0.896,2-2s-0.896-2-2-2c-4.082,0-7.504,2.844-8.41,6.652H22.344c-1.104,0-2,0.896-2,2 s0.896,2,2,2h13.223c0.906,3.808,4.328,6.652,8.41,6.652c1.104,0,2-0.896,2-2s-0.896-2-2-2c-2.565,0-4.652-2.087-4.652-4.652 S41.411,43.348,43.977,43.348z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertexCut);
export default __webpack_public_path__ + "static/media/vertex-cut.a2dcc127537b796c285146daa9748e7b.svg";
export { ForwardRef as ReactComponent };